import SVG from 'helpers/SVG/SVG';
import { LocationSearchProps } from './LocationTypes';
import classNames from 'classnames';

// LocationSearch component
const LocationSearch: React.FC<LocationSearchProps> = ({
  setSearchValue,
  searchValue,
  onSearch,
  onGetCurrentLocation,
  searchPlaceholderText,
}) => {
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleSearch = () => {
    onSearch(searchValue);
  };

  return (
    <div className="location-search mb-[21px]">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSearch();
        }}
        className="block"
      >
        <div className="flex items-center h-12 min-w-full relative">
          <input
            type="search"
            placeholder={searchPlaceholderText}
            className={classNames(
              'border rounded-full h-full w-full px-4 border-light-other-randomGray1 p2-medium',
              'focus:outline focus:outline-2 focus:outline-light-stroke-primary-variant'
            )}
            value={searchValue}
            onChange={handleSearchChange}
          />
          <button
            type="button"
            onClick={() => {
              onGetCurrentLocation();
            }}
            className="w-3 h-4 absolute right-18 focus:outline-none"
          >
            <SVG
              svg="icon-location-2"
              className="text-light-fill-secondary [&_svg]:w-3 [&_svg]:h-4 focus:[&_svg]:outline-none"
            />
          </button>
          <button
            type="submit"
            className="absolute right-0 w-[57px] h-full flex items-center justify-center rounded-r-full bg-light-background-gradient hover:bg-light-background-gradient-active focus:bg-light-background-gradient-focus outline-none focus:outline-none"
          >
            <SVG
              svg="icon-search2"
              className="[&_svg]:w-6 [&_svg]:h-6 [&_path]:stroke-light-fill-inverse"
            />
          </button>
        </div>
      </form>
    </div>
  );
};

export default LocationSearch;
